// Stato di Ghost Mode per il RENDERER, in un modulo e non in un context.
//
// Perche': lo stato vero vive nel main Electron (`electron/lib/settings.mjs`) ed e' gia' sincronizzato
// dalla barra desktop (`JarvisDesktopBar`). Il menu account e' un altro albero di componenti e non puo'
// riceverlo via props: qui si pubblica una volta e si legge ovunque.
//
// Perche' conta (decisione 2026-10-23): Ghost Mode ON accende `setContentProtection(true)` =
// WDA_EXCLUDEFROMCAPTURE, quindi la finestra NON e' catturabile. L'identita' reale (nome + foto) si
// mostra SOLO in quello stato: in una finestra catturabile (Ghost OFF, cioe' quando si registrano i
// video della landing) si mostra "Guest" senza foto. Cosi' un video pubblico non puo' contenere il
// nome o la foto dell'utente: e' una proprieta' strutturale, non una cosa da ricordarsi.
//
// Default `false` (mascherato) di proposito: il primo render non deve MAI mostrare il nome vero prima
// di sapere se la finestra e' protetta. Il valore persistito in localStorage copre i render successivi.
import { useSyncExternalStore } from 'react';

export const GHOST_STORAGE_KEY = 'jarvis_ghost_protected';

function readPersisted(): boolean {
  try {
    return localStorage.getItem(GHOST_STORAGE_KEY) === '1';
  } catch {
    return false; // storage negato (privacy mode): si resta mascherati
  }
}

let protectedNow = readPersisted();
const listeners = new Set<() => void>();

/** Lettura sincrona: usabile anche fuori da React (es. utilita' non-componente). */
export function isGhostProtected(): boolean {
  return protectedNow;
}

/** Pubblica lo stato: la chiama la barra a ogni cambio (settings, evento, toggle). */
export function setGhostProtected(value: boolean): void {
  const next = Boolean(value);
  if (next === protectedNow) return;
  protectedNow = next;
  try {
    localStorage.setItem(GHOST_STORAGE_KEY, next ? '1' : '0');
  } catch {
    /* storage negato: lo stato resta valido per la sessione corrente */
  }
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** Ri-renderizza il componente a ogni cambio di Ghost Mode. */
export function useGhostProtected(): boolean {
  return useSyncExternalStore(subscribe, isGhostProtected, () => false);
}

/** Solo per i test: riporta il modulo allo stato iniziale. */
export function resetGhostModeForTests(): void {
  protectedNow = false;
  listeners.clear();
  try {
    localStorage.removeItem(GHOST_STORAGE_KEY);
  } catch { /* no-op */ }
}
